import "babel-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
const { register } = require("@lpm/pug-components/dist/register");

// These components are used in all 3 sites
import CookiePolicy from "./CookiePolicy/CookiePolicy";
import AlphaPagination from "./AlphaPagination/AlphaPagination";
import HamburgerMenu from "./HamburgerMenu/HamburgerMenu";
import InlineSearch from "./InlineSearch/InlineSearch";
import Pagination from "./Pagination/Pagination";

// These components are used in LM and CLM
import ArticleNavigation from "./ArticleNavigation/ArticleNavigation"; // Using render.static since it is not interactive
import MagazineFilter from "./MagazineFilter/MagazineFilter";
import TrendsNav from "./TrendsNav/TrendsNav";

// These components are used in LM and DDN
import SearchBar from "./SearchBar/SearchBar";

// These components are used in LM
import ArticleWidget from "./ArticleWidget/ArticleWidget";

// These components are used in CLM
import Slideshow from "./Slideshow/Slideshow";

// currently CSR components
import SignInAndSearch from "./SignInAndSearch/SignInAndSearch";
import SearchPopUp from "./SearchPopUp/SearchPopUp";
import CLMNewsletter from "./CLMNewsletter/CLMNewsletter";
import VendorTagFilter from "./VendorTagFilter/VendorTagFilter";
import ArticleSection from "./ArticleSection/ArticleSection";
import MagazineGate from "./MagazineGate/MagazineGate";
import AcademyGate from "./AcademyGate/AcademyGate"
import Toast from "./Toast/Toast";

register("CookiePolicy/CookiePolicy", CookiePolicy);
const signInAndSearch = document.getElementById("SignInAndSearch");
register("HamburgerMenu/HamburgerMenu", HamburgerMenu);
register("Slideshow/Slideshow", Slideshow);
register("Pagination/Pagination", Pagination);
register("AlphaPagination/AlphaPagination", AlphaPagination);
register("MagazineFilter/MagazineFilter", MagazineFilter);
register("SearchBar/SearchBar", SearchBar);
const vendorTagFilter = document.getElementById("VendorTagFilter");
register("TrendsNav/TrendsNav", TrendsNav);
const articleSections = document.getElementsByClassName("ArticleSection");
register("ArticleNavigation/ArticleNavigation", ArticleNavigation);

const currentIssue = document.getElementById("CurrentIssue");
const newsletter = document.getElementById("Newsletter");

const searchPopUps = document.getElementsByClassName("SearchPopUp");
register("InlineSearch/InlineSearch", InlineSearch);

const articleGroups = document.getElementsByClassName("ArticleGroup");
const articleTabLists = document.getElementsByClassName("ArticleTabList");
const featuredArticles = document.getElementsByClassName("FeaturedArticleList");
register("ArticleWidget/ArticleWidget", ArticleWidget);

const magazineGates = document.getElementsByClassName("MagazineGate");
const academyGates = document.getElementsByClassName("AcademyGate");

const toast  = document.getElementById("Toast");

if(articleGroups) {
    for(let i = 0; i<articleGroups.length; i++) {
        let ad = articleGroups[i].dataset.ad ? articleGroups[i].dataset.ad : "";

        let params = {
            title: articleGroups[i].dataset.title ? articleGroups[i].dataset.title : "",
            slugs: articleGroups[i].dataset.slugs ? articleGroups[i].dataset.slugs : "",
            exclude: articleGroups[i].dataset.exclude ? articleGroups[i].dataset.exclude : "",
            ad
        };

        axios.get("/api/article-group", {
            params
        }).then((response) => {
            articleGroups[i].innerHTML = response.data;
            if(ad) {
                //init ad if one is being loaded
                let adSlots = articleGroups[i].querySelectorAll("[data-zone]");
                let loadNewAdsEvent = new CustomEvent("loadNewAds", {detail: adSlots});

                window.dispatchEvent(loadNewAdsEvent);
            }
        });
    }
}

if(articleTabLists) {
    for(let i = 0; i<articleTabLists.length; i++) {
        let params = {};
        if(articleTabLists[i].dataset.config) {
            params = JSON.parse(articleTabLists[i].dataset.config);

            params.id = articleTabLists[i].dataset.id ? articleTabLists[i].dataset.id : "";
            params.ad = articleTabLists[i].dataset.ad ? articleTabLists[i].dataset.ad : "";

            if(params.slugs) {
                params.slugs = params.slugs.join(",");
            }
            if(params.contentTypes) {
                params.contentTypes = params.contentTypes.join(",");
            }
            if(params.magazineSections) {
                params.magazineSections = params.magazineSections.join(",");
            }
        }

        axios.get("/api/article-tab-list", {
            params
        }).then((response) => {
            articleTabLists[i].innerHTML = response.data;
            if(params.ad) {
                let adSlots = articleTabLists[i].querySelectorAll("[data-zone]");

                adSlots.forEach(function(slot) {
                    if(params.adTargetId && params.adTargetName){
                        slot.classList.remove("unamedAd");
                        slot.classList.add(`${params.adTargetName}-ad`);
                        slot.setAttribute("data-adtargetvalue", +params.adTargetId);
                    }
                });
                let loadNewAdsEvent = new CustomEvent("loadNewAds", {detail: adSlots});

                window.dispatchEvent(loadNewAdsEvent);
            }
        });
    }
}

if(featuredArticles) {
    for(let i = 0; i<featuredArticles.length; i++) {
        let params = {};

        let queryKey = "";
        let queryValue = "";

        if(featuredArticles[i].dataset.category) {
            queryKey = `categoryno`;
            queryValue = featuredArticles[i].dataset.category;
        }
        if(featuredArticles[i].dataset.contenttype) {
            queryKey = `contentType`;
            queryValue = featuredArticles[i].dataset.contenttype;
        }
        if(featuredArticles[i].dataset.magazinesection) {
            queryKey = `magazineIssueSectionNo`;
            queryValue = featuredArticles[i].dataset.magazinesection;
        }

        params.queryKey = queryKey;
        params.queryValue = queryValue;
        params.offset = featuredArticles[i].dataset.offset ? featuredArticles[i].dataset.offset : 0;
        params.numArticles = featuredArticles[i].dataset.number ? featuredArticles[i].dataset.number : 3; //default to 3 articles

        axios.get("/api/featured-articles", {
            params
        }).then((response) => {
            featuredArticles[i].innerHTML = response.data;
        });
    }
}

if (articleSections) {
    for (let i = 0; i < articleSections.length; i++) {
        let dataset = articleSections[i].dataset;

        ReactDOM.render(
            <ArticleSection
                autoAttached={dataset.autoattached === "true" ? true : false}
                article={dataset.article ? dataset.article : null}
                preview={typeof dataset.preview !== "undefined" ? true : false}
                order={dataset.order ? dataset.order : null}
            />,
            articleSections[i]
        );
    }
}

if(searchPopUps) {
    for(let i = 0; i<searchPopUps.length; i++) {
        ReactDOM.render(<SearchPopUp isSearchOn={(searchPopUps[i].dataset.search==="true")?true:false}/>, searchPopUps[i]);
    }
}

if(currentIssue) {
    axios.get("/api/current-issue").then((response) => {
        currentIssue.innerHTML = response.data;
    });
}

if(signInAndSearch) {
    ReactDOM.render(<SignInAndSearch isSignInOn={(signInAndSearch.dataset.signin==="true")?true:false} isSearchOn={(signInAndSearch.dataset.search==="true")?true:false} isMobile={(signInAndSearch.dataset.mobile==="true")?true:false}/>, signInAndSearch);
}

if(vendorTagFilter) {
    ReactDOM.render(<VendorTagFilter tags={vendorTagFilter.dataset.tags}/>, vendorTagFilter);
}

if(newsletter) {
    ReactDOM.render(<CLMNewsletter config={JSON.parse(newsletter.dataset.config)} cdnpath={newsletter.dataset.cdnpath || "/"}/>, newsletter);
}

if(magazineGates) {
    for(let i = 0; i<magazineGates.length; i++) {
        ReactDOM.render(<MagazineGate text={magazineGates[i].dataset.text} classes={magazineGates[i].dataset.classes} glyph={magazineGates[i].dataset.glyph} redirectUrl={magazineGates[i].dataset.redirecturl} sitename={magazineGates[i].dataset.sitename} />, magazineGates[i]);
    }
}
if(academyGates) {
    for(let i = 0; i <academyGates.length; i++) {
        ReactDOM.render(<AcademyGate />, academyGates[i]);
    }
}
if(toast) {
    ReactDOM.render(<Toast />, toast);
}
